import { useState, useRef } from 'react';

import styled from 'styled-components';

export default function NewProductCountInput(props) {
	const { value, setValue, placeholder, width } = props;

	const [clickCount, setClickCount] = useState(0);

	const inputRef = useRef();

	// 입력값 변경 처리 //
	function onChangeInput(e) {
    const val = e.target.value;

    if (val === '') { setValue(''); return; }

    const num = parseInt(val);

    if (isNaN(num) || num < 1) return;

    setValue(num);
	}

	// 입력 필드 포커스 해제 처리 //
	function onBlurInput() {
		if (value === '' || value === undefined) setValue(1);
		setClickCount(clickCount + 1);
	}

	return (
    <TopLevelWrapper>
      <InputWrapper width={width}>
        <Input
          ref={inputRef}
          clickCount={clickCount}
          placeholder={placeholder}
          value={value || ""}
          onChange={onChangeInput}
          onBlur={onBlurInput} />
      </InputWrapper>
      <Text>개</Text>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const InputWrapper = styled.div`
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
  gap: 5px;

  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: 50px;

  background: ${props => props.theme.subBackground};
  border: 1px solid ${props => props.theme.line};
  border-radius: 10px;

  flex-grow: 1;

  transition: border-color 0.3s ease-in-out;
`;

const Input = styled.input`
  width: 100%;
  height: 21px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 17px;

  text-align: right;

  color: ${props => props.theme.text};
  background: transparent;

  border: none;
  outline: none;
  padding: 0;

  ::placeholder {
  	color: ${props => props.theme.subText};
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.text};

  margin: 0px 0px 0px 5px;
`;
